import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1312 806.001C1312 850.183 1276.18 886.001 1232 886.001 1187.82 886.001 1152 850.183 1152 806.001 1152 761.818 1187.82 726.001 1232 726.001 1276.18 726.001 1312 761.818 1312 806.001zM688 886.001C732.183 886.001 768 850.183 768 806.001 768 761.818 732.183 726.001 688 726.001 643.817 726.001 608 761.818 608 806.001 608 850.183 643.817 886.001 688 886.001zM1525.33 955.334C1525.33 999.516 1489.52 1035.334 1445.33 1035.334 1401.15 1035.334 1365.33 999.516 1365.33 955.334 1365.33 911.151 1401.15 875.334 1445.33 875.334 1489.52 875.334 1525.33 911.151 1525.33 955.334zM1573.33 1259.33C1617.52 1259.33 1653.33 1223.52 1653.33 1179.33 1653.33 1135.15 1617.52 1099.33 1573.33 1099.33 1529.15 1099.33 1493.33 1135.15 1493.33 1179.33 1493.33 1223.52 1529.15 1259.33 1573.33 1259.33zM554.666 955.334C554.666 999.516 518.849 1035.334 474.666 1035.334 430.484 1035.334 394.666 999.516 394.666 955.334 394.666 911.151 430.484 875.334 474.666 875.334 518.849 875.334 554.666 911.151 554.666 955.334zM346.667 1259.33C390.849 1259.33 426.667 1223.52 426.667 1179.33 426.667 1135.15 390.849 1099.33 346.667 1099.33 302.484 1099.33 266.667 1135.15 266.667 1179.33 266.667 1223.52 302.484 1259.33 346.667 1259.33zM1040 747.334C1040 791.516 1004.18 827.334 960 827.334 915.817 827.334 880 791.516 880 747.334 880 703.151 915.817 667.334 960 667.334 1004.18 667.334 1040 703.151 1040 747.334z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,1440.67 C0,910.474 429.807,480.667 960,480.667 C1490.19,480.667 1920,910.474 1920,1440.67 L0,1440.67 Z M658.209,1334 L1261.79,1334 C1217.86,1209.71 1099.33,1120.67 960,1120.67 C820.67,1120.67 702.138,1209.71 658.209,1334 Z M1373.22,1334 C1325.86,1149.98 1158.81,1014 960,1014 C761.19,1014 594.14,1149.98 546.775,1334 L113.269,1334 C165.759,913.06 524.841,587.334 960,587.334 C1395.16,587.334 1754.24,913.06 1806.73,1334 L1373.22,1334 Z"
}));

var IconProtractorLine = /*#__PURE__*/function (_Component) {
  _inherits(IconProtractorLine, _Component);

  var _super = _createSuper(IconProtractorLine);

  function IconProtractorLine() {
    _classCallCheck(this, IconProtractorLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconProtractorLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconProtractor",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconProtractorLine.displayName = "IconProtractorLine";
  return IconProtractorLine;
}(Component);

IconProtractorLine.glyphName = 'protractor';
IconProtractorLine.variant = 'Line';
IconProtractorLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconProtractorLine;
export { IconProtractorLine };